export class InfoAnagrafichePFDTO {
	nome: string;
	cognome: string;
	codFiscale: string;
	codiceRegione: string;
}